'use client';

export function AgentLogsMockup() {
  return (
    <div className="w-full bg-card rounded-none shadow-2xl overflow-hidden border border-border-subtle">
      <div className="flex items-center px-4 py-3 border-b border-border-subtle bg-canvas">
        <div className="flex gap-2 mr-4">
          <div className="w-2.5 h-2.5 rounded-full bg-[#FF5F56]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#FFBD2E]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#27CA40]" />
        </div>
        <div className="flex-1 flex justify-center">
          <div className="px-4 py-1.5 bg-card border border-border-subtle text-label text-text-tertiary font-mono min-w-[240px] text-center">
            app.sentrial.com/logs/session_9a8b
          </div>
        </div>
        <div className="w-[54px]" />
      </div>
      <div className="flex h-[320px]">
        {/* Left Sidebar - Timeline */}
        <div className="w-1/3 border-r border-border-subtle bg-canvas p-4 space-y-3 overflow-y-auto">
          <div className="p-2 bg-card border border-[#2563EB] border-l-4 shadow-card-xs">
            <div className="text-[10px] font-bold text-[#2563EB] mb-1 tracking-wider">
              USER INPUT
            </div>
            <div className="text-label text-ink truncate">"How do I reset my password?"</div>
          </div>
          <div className="p-2 bg-card border border-border-subtle opacity-70">
            <div className="text-[10px] font-bold text-gold mb-1 tracking-wider">TOOL CALL</div>
            <div className="text-label text-ink truncate">search_docs("password reset")</div>
          </div>
          <div className="p-2 bg-card border border-border-subtle opacity-70">
            <div className="text-[10px] font-bold text-[#9333EA] mb-1 tracking-wider">
              LLM RESPONSE
            </div>
            <div className="text-label text-ink truncate">Generating reply...</div>
          </div>
        </div>
        {/* Right Content - Details */}
        <div className="w-2/3 p-6 bg-card font-mono text-label">
          <div className="flex justify-between mb-4 pb-2 border-b border-border-subtle">
            <span className="text-ink font-bold">User Input Details</span>
            <span className="text-text-tertiary">0.00s</span>
          </div>
          <div className="space-y-2 text-text-secondary">
            <p>
              <span className="text-text-tertiary">timestamp:</span> 2026-03-20 14:32:01
            </p>
            <p>
              <span className="text-text-tertiary">user_id:</span> usr_77x91p
            </p>
            <p>
              <span className="text-text-tertiary">message:</span> "How do I reset my password?"
            </p>
            <div className="mt-4 p-3 bg-[#F8FAFC] dark:bg-[#0F0F11] border border-[#E2E8F0] dark:border-[#26262D] rounded-none text-ink whitespace-pre">
              {`{
  "context": "authenticated",
  "intent": "support_query",
  "sentiment": "neutral"
}`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function SignalsMockup() {
  return (
    <div className="w-full bg-card rounded-none shadow-2xl overflow-hidden border border-border-subtle">
      <div className="px-6 py-4 border-b border-border-subtle bg-canvas flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div className="flex gap-2 mr-2">
            <div className="w-2.5 h-2.5 rounded-full bg-[#FF5F56]" />
            <div className="w-2.5 h-2.5 rounded-full bg-[#FFBD2E]" />
            <div className="w-2.5 h-2.5 rounded-full bg-[#27CA40]" />
          </div>
          <h3 className="text-[15px] font-medium text-ink">Active Signals & Assertions</h3>
        </div>
        <span className="px-3 py-1.5 bg-[#050A15] text-white text-label font-medium rounded-none">
          New Signal
        </span>
      </div>
      <div className="p-6 space-y-4">
        {[
          {
            name: 'User Frustration',
            desc: 'User expressed frustration, anger, or dissatisfaction',
            active: true,
            hits: 24,
          },
          {
            name: 'Hallucination Suspected',
            desc: 'Agent may have made up information not grounded in the provided context',
            active: true,
            hits: 12,
          },
          {
            name: 'Inappropriate Refusal',
            desc: 'Agent refused a reasonable request it should have handled',
            active: false,
            hits: 0,
          },
        ].map((signal, i) => (
          <div
            key={i}
            className={`p-4 border ${signal.active ? 'border-warm-brown bg-canvas' : 'border-border-subtle bg-card'} flex items-start justify-between`}
          >
            <div>
              <div className="flex items-center gap-2 mb-1">
                <h4 className="text-body font-bold text-ink">{signal.name}</h4>
                {signal.active && (
                  <span className="px-2 py-0.5 bg-[#F0FDF4] dark:bg-[#0F2E22] text-[#16A34A] text-[10px] uppercase font-bold border border-[#BBF7D0]">
                    Active
                  </span>
                )}
              </div>
              <p className="text-label text-[#64748B] dark:text-[#A1A1AA]">{signal.desc}</p>
            </div>
            <div className="flex flex-col items-end gap-2">
              {/* Toggle switch */}
              <div
                className={`w-8 h-4 rounded-full ${signal.active ? 'bg-[#16A34A]' : 'bg-[#CBD5E1] dark:bg-[#3A3A42]'} relative`}
              >
                <div
                  className={`absolute top-0.5 w-3 h-3 rounded-full bg-card transition-all`}
                  style={{ left: signal.active ? '18px' : '2px' }}
                />
              </div>
              {signal.active && (
                <span className="text-tiny text-text-tertiary">{signal.hits} hits today</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ABTestsMockup() {
  return (
    <div className="w-full bg-card rounded-none shadow-2xl overflow-hidden border border-border-subtle">
      <div className="px-6 py-4 border-b border-border-subtle bg-canvas">
        <div className="flex gap-2 mb-3">
          <div className="w-2.5 h-2.5 rounded-full bg-[#FF5F56]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#FFBD2E]" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#27CA40]" />
        </div>
        <h3 className="text-[15px] font-medium text-ink">Prompt Experiment: Onboarding Flow</h3>
        <p className="text-label text-[#64748B] dark:text-[#A1A1AA] mt-1">
          Illustrative comparison · sample data
        </p>
      </div>
      <div className="p-6 flex flex-col sm:flex-row gap-6">
        {/* Variant A */}
        <div className="flex-1 border border-border-subtle p-5 bg-card relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-[#94A3B8]" />
          <h4 className="text-body-sm font-bold text-ink mb-5">Variant A (Control)</h4>
          <div className="space-y-4">
            <div>
              <div className="flex justify-between text-tiny text-[#64748B] dark:text-[#A1A1AA] mb-1.5">
                <span>Success Rate</span>
                <span>68.4%</span>
              </div>
              <div className="w-full h-1.5 bg-[#F1F5F9] dark:bg-[#1A1A1F]">
                <div className="h-full bg-[#94A3B8] w-[68.4%]" />
              </div>
            </div>
            <div>
              <div className="flex justify-between text-tiny text-[#64748B] dark:text-[#A1A1AA] mb-1.5">
                <span>Avg Latency</span>
                <span>2.4s</span>
              </div>
              <div className="w-full h-1.5 bg-[#F1F5F9] dark:bg-[#1A1A1F]">
                <div className="h-full bg-[#94A3B8] w-[40%]" />
              </div>
            </div>
          </div>
        </div>

        {/* Variant B */}
        <div className="flex-1 border border-[#16A34A] p-5 bg-[#F0FDF4] dark:bg-[#0F2E22] relative overflow-hidden shadow-card-xs">
          <div className="absolute top-0 left-0 w-full h-1 bg-[#16A34A]" />
          <div className="flex justify-between items-center mb-5">
            <h4 className="text-body-sm font-bold text-ink">Variant B (New)</h4>
            <span className="text-[10px] font-bold text-[#16A34A] uppercase bg-[#DCFCE7] dark:bg-[#0F2E22] px-2 py-0.5 border border-[#BBF7D0]">
              Sample
            </span>
          </div>
          <div className="space-y-4">
            <div>
              <div className="flex justify-between text-tiny text-ink font-medium mb-1.5">
                <span>Success Rate</span>
                <span className="text-[#16A34A]">82.1%</span>
              </div>
              <div className="w-full h-1.5 bg-[#DCFCE7] dark:bg-[#0F2E22]">
                <div className="h-full bg-[#16A34A] w-[82.1%]" />
              </div>
            </div>
            <div>
              <div className="flex justify-between text-tiny text-ink font-medium mb-1.5">
                <span>Avg Latency</span>
                <span className="text-[#16A34A]">1.8s</span>
              </div>
              <div className="w-full h-1.5 bg-[#DCFCE7] dark:bg-[#0F2E22]">
                <div className="h-full bg-[#16A34A] w-[30%]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function SlackAlertsMockup() {
  return (
    <div className="w-full max-w-[420px] mx-auto bg-card rounded-lg shadow-2xl overflow-hidden border border-border-subtle font-sans">
      <div className="bg-[#3F0E40] px-4 py-3 flex items-center gap-3">
        <div className="w-3 h-3 rounded-full bg-[#2BAC76]" />
        <span className="text-white font-bold text-body">#alerts-sentrial</span>
      </div>
      <div className="p-5 flex gap-4">
        <div className="w-10 h-10 rounded bg-[#050A15] flex-shrink-0 flex items-center justify-center">
          <span className="text-white font-bold text-[18px]">S</span>
        </div>
        <div>
          <div className="flex items-baseline gap-2 mb-1">
            <span className="font-bold text-ink text-[15px]">Sentrial Bot</span>
            <span className="text-[#616061] text-label bg-[#F2F2F2] dark:bg-[#16161A] px-1 rounded">
              APP
            </span>
            <span className="text-[#616061] text-label">10:42 AM</span>
          </div>
          <p className="text-ink text-[15px] leading-snug mb-3">
            🚨 <span className="font-bold">Spike in Tool Timeouts Detected</span>
          </p>
          <div className="border-l-4 border-[#E01E5A] pl-3 py-1 mb-3">
            <p className="text-body text-ink mb-1">
              <span className="font-bold">Agent:</span> Customer Support Bot
              <br />
              <span className="font-bold">Tool:</span>{' '}
              <code className="text-[#E01E5A] bg-[#F8F8F8] dark:bg-[#16161A] px-1.5 py-0.5 rounded text-label border border-border-subtle">
                fetch_user_billing
              </code>
              <br />
              <span className="font-bold">Impact:</span> 45 sessions in last 10 mins
            </p>
          </div>
          <div className="flex gap-2 mt-4">
            <span className="px-3 py-1.5 border border-[#D1D2D3] dark:border-[#26262D] rounded text-body-sm font-bold text-ink hover:bg-[#F8F8F8] dark:hover:bg-[#16161A] transition-colors">
              View Traces
            </span>
            <span className="px-3 py-1.5 border border-[#D1D2D3] dark:border-[#26262D] rounded text-body-sm font-bold text-ink hover:bg-[#F8F8F8] dark:hover:bg-[#16161A] transition-colors">
              Acknowledge
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function CodebaseResolutionMockup() {
  return (
    <div className="w-full bg-white dark:bg-[#1E1E1E] rounded-none shadow-2xl overflow-hidden border border-[#E5E5E5] dark:border-[#333] font-mono text-body-sm">
      <div className="flex items-center px-4 py-2 bg-[#F3F3F3] dark:bg-[#2D2D2D] border-b border-[#E5E5E5] dark:border-[#1E1E1E]">
        <div className="flex gap-2 mr-4">
          <div className="w-3 h-3 rounded-full bg-[#FF5F56]" />
          <div className="w-3 h-3 rounded-full bg-[#FFBD2E]" />
          <div className="w-3 h-3 rounded-full bg-[#27CA40]" />
        </div>
        <div className="flex gap-2 text-[#6E6E6E] dark:text-[#969696] text-label">
          <span className="bg-white dark:bg-[#1E1E1E] px-4 py-1.5 text-[#333333] dark:text-[#D4D4D4] border-t border-[#007ACC]">
            tools/billing.ts
          </span>
          <span className="px-4 py-1.5">prompts/support.ts</span>
        </div>
      </div>
      <div className="py-4 text-[#333333] dark:text-[#D4D4D4] leading-relaxed">
        {/* Line 42 */}
        <div className="flex px-4">
          <div className="w-10 text-[#9B9B9B] dark:text-[#858585] text-right pr-4 select-none">
            42
          </div>
          <div className="flex-1 whitespace-pre">
            <span className="text-[#0000FF] dark:text-[#569CD6]">async function</span>{' '}
            <span className="text-[#795E26] dark:text-[#DCDCAA]">fetchUserBilling</span>(userId:{' '}
            <span className="text-[#267F99] dark:text-[#4EC9B0]">string</span>) {'{'}
          </div>
        </div>

        {/* Line 43 */}
        <div className="flex px-4">
          <div className="w-10 text-[#9B9B9B] dark:text-[#858585] text-right pr-4 select-none">
            43
          </div>
          <div className="flex-1 whitespace-pre">
            {' '}
            <span className="text-[#AF00DB] dark:text-[#C586C0]">try</span> {'{'}
          </div>
        </div>

        {/* Line 44 - Highlighted Error */}
        <div className="flex pl-[12px] pr-4 py-0.5 bg-[#FDECEC] dark:bg-[#4A1919] border-l-4 border-[#F14C4C]">
          <div className="w-10 text-[#9B9B9B] dark:text-[#858585] text-right pr-4 select-none">
            44
          </div>
          <div className="flex-1 whitespace-pre">
            {' '}
            <span className="text-[#0000FF] dark:text-[#569CD6]">const</span> res ={' '}
            <span className="text-[#AF00DB] dark:text-[#C586C0]">await</span> api.
            <span className="text-[#795E26] dark:text-[#DCDCAA]">get</span>(
            <span className="text-[#A31515] dark:text-[#CE9178]">`/billing/`</span> + userId);
          </div>
        </div>

        {/* Inline Sentrial Overlay (VS Code Peek Style) */}
        <div className="flex my-2 px-4">
          <div className="w-10"></div>
          <div className="flex-1 bg-[#F3F3F3] dark:bg-[#252526] border border-[#C8C8C8] dark:border-[#454545] shadow-inner p-4 relative">
            {/* Little pointer arrow */}
            <div className="absolute -top-2 left-4 w-3 h-3 bg-[#F3F3F3] dark:bg-[#252526] border-t border-l border-[#C8C8C8] dark:border-[#454545] rotate-45"></div>

            <div className="flex items-center gap-2 mb-3 border-b border-[#C8C8C8] dark:border-[#454545] pb-3">
              <div className="w-5 h-5 rounded-full bg-warm-brown flex items-center justify-center text-tiny font-bold text-white">
                S
              </div>
              <span className="text-[#333333] dark:text-[#CCCCCC] font-bold text-body-sm">
                Sentrial Insight
              </span>
            </div>
            <p className="text-[#6E6E6E] dark:text-[#969696] text-label mb-4 leading-relaxed">
              This endpoint is timing out because{' '}
              <code className="text-[#A31515] dark:text-[#CE9178] bg-[#EDEDED] dark:bg-[#1E1E1E] px-1 py-0.5">
                userId
              </code>{' '}
              is frequently passed as{' '}
              <code className="text-[#0000FF] dark:text-[#569CD6] bg-[#EDEDED] dark:bg-[#1E1E1E] px-1 py-0.5">
                undefined
              </code>{' '}
              by the agent.
            </p>
            <div className="bg-[#F3F3F3] dark:bg-[#1E1E1E] p-3 text-label border border-[#E5E5E5] dark:border-[#333] mb-4">
              <span className="text-[#267F99] dark:text-[#4EC9B0]">Suggestion:</span> Add validation
              before API call.
            </div>
            <div className="flex justify-end">
              <span className="bg-[#0E639C] hover:bg-[#1177BB] text-white px-4 py-1.5 text-label transition-colors">
                Suggested change
              </span>
            </div>
          </div>
        </div>

        {/* Line 45 */}
        <div className="flex px-4">
          <div className="w-10 text-[#9B9B9B] dark:text-[#858585] text-right pr-4 select-none">
            45
          </div>
          <div className="flex-1 whitespace-pre">
            {' '}
            <span className="text-[#AF00DB] dark:text-[#C586C0]">return</span> res.data;
          </div>
        </div>

        {/* Line 46 */}
        <div className="flex px-4">
          <div className="w-10 text-[#9B9B9B] dark:text-[#858585] text-right pr-4 select-none">
            46
          </div>
          <div className="flex-1 whitespace-pre">
            {' '}
            {'}'} <span className="text-[#AF00DB] dark:text-[#C586C0]">catch</span> (e) {'{'}
          </div>
        </div>
      </div>
    </div>
  );
}
